import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  standalone: true,
  templateUrl: './progress-bar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './progress-bar.component.css',
})
export class ProgressBarComponent implements OnInit {
  @Input() duration = 5000; // milliseconds
  @Input() color = 'rgba(255, 255, 255, 0.7)';

  animationDuration = '5s';

  ngOnInit(): void {
    this.animationDuration = `${this.duration / 1000}s`;
  }
}
